import React from 'react';
import PropTypes from 'prop-types';
import {DangerButton, DefaultButton, Modal} from "../../../components";

class ClearSampleButton extends React.Component {
  state = {showModal: false};

  showModal = () => this.setState(({showModal: true}));
  hideModal = () => this.setState(({showModal: false}));
  clearData = () => this.setState(({showModal: false}), () => this.props.deleteSampleData());

  renderModal() {
    const {showModal} = this.state;
    return (
      <Modal
        show={showModal}
        title="Clear Sample Data"
        onClose={this.hideModal}
        body={<div>Are you sure?</div>}
        footer={
          <React.Fragment>
            <DefaultButton onClick={this.hideModal}>Close</DefaultButton>
            <DangerButton onClick={this.clearData}>Clear Sample</DangerButton>
          </React.Fragment>
        }
      />
    )
  }

  renderButton() {
    const {disabled, className} = this.props;
    return (
      <DangerButton
        className={className}
        disabled={disabled}
        onClick={this.showModal}
      >
        Clear Sample
      </DangerButton>
    )
  }

  render() {
    return (
      <React.Fragment>
        {this.renderButton()}
        {this.renderModal()}
      </React.Fragment>
    );
  }
}

ClearSampleButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  deleteSampleData: PropTypes.func.isRequired,
};

export default ClearSampleButton;



// WEBPACK FOOTER //
// ./src/modules/sample/components/ClearSampleButton.js